module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-584.1e38362.woff2";